
/**
 * Servicios API
 *
 * @class ServiceApi
 */
class ServiceApi {

  /**
   * Obtiene el código de país por la IP
   * @returns {Promise<string>}
   */
  getCountryCodeByIp() {
    return fetch('https://ipapi.co/json/')
      .then(response => response.json())
      .then(data => data)
  }
}

export default ServiceApi;
